module.exports = __webpack_public_path__ + "static/img/img11.cd399a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/img11.jpg
// module id = dTWD
// module chunks = 0